import React, { useEffect, useState } from "react";
import { Modal, ModalBody, ModalHeader } from "reactstrap";
import { RootState } from "../../redux/rootReducers";
import { resetSession } from "../../redux/auth";
import {
  getTimeSheetUnfilledReportAction,
  resetTimeSheetError,
  resetTimeSheetMessage,
  resetTimeSheetStatusCode,
  resetTimeSheetSuccess,
  resetUnfilledTimesheetCount,
  resetUnfilledTimesheetReportList,
} from "../../redux/timeSheet";
import { connect } from "react-redux";
import {
  EmptyListPage,
  ErrorSuccessModal,
  TableHeader,
  TableLoader,
} from "../commons";
import { TIMESHEET_UNFILLED_REPORT_HEADERS } from "../../constant/tableHeadersConstants/timeSheetConstants/timeSheetUnfilledReportConsts";
import TimeSheetUnfilledDatesReportTable from "./TimeSheetUnfilledDatesReportTable";
import { Toaster } from "react-hot-toast";
import { GetMissingTimesheetSummaryReport } from "../../commonTypes/timeSheetTypes";

type AppProps = {
  isOpen: boolean;
  token: string | null;
  toggle: () => void;
  statusCode: number | null;
  success: number | null;
  error: string | null;
  message: string | null;
  fetching: boolean;
  unfilledTimesheetReportList: [];
  unfilledTimesheetCount: string | number;
  dispatchGetTimeSheetUnfilledDatesReportAction: (
    data: GetMissingTimesheetSummaryReport
  ) => void;
  dispatchResetTimeSheetReportSuccess: () => void;
  dispatchResetTimeSheetReportError: () => void;
  dispatchResetTimeSheetReportMessage: () => void;
  dispatchResetTimeSheetReportStatusCode: () => void;
  dispatchResetSession: () => void;
  dispatchResetUnfilledTimeSheetReportTotalCount: () => void;
  dispatchResetUnfilledTimeSheetReportListing: () => void;
};
const OpenTimeSheetUnfilledDateModal = ({
  isOpen,
  toggle,
  statusCode,
  success,
  error,
  message,
  fetching,
  token,
  unfilledTimesheetReportList,
  unfilledTimesheetCount,
  dispatchGetTimeSheetUnfilledDatesReportAction,
  dispatchResetTimeSheetReportSuccess,
  dispatchResetTimeSheetReportError,
  dispatchResetTimeSheetReportMessage,
  dispatchResetTimeSheetReportStatusCode,
  dispatchResetSession,
  dispatchResetUnfilledTimeSheetReportTotalCount,
  dispatchResetUnfilledTimeSheetReportListing,
}: AppProps) => {
  const [data, setData] = useState<[] | any[]>([]);

  useEffect(() => {
    dispatchResetTimeSheetReportSuccess();
    dispatchResetTimeSheetReportError();
    dispatchResetTimeSheetReportMessage();
    dispatchResetTimeSheetReportStatusCode();
    dispatchResetUnfilledTimeSheetReportTotalCount();
    dispatchResetUnfilledTimeSheetReportListing();
  }, []);

  useEffect(() => {
    if (token) {
      dispatchGetTimeSheetUnfilledDatesReportAction({ token });
    }
  }, []);

  const handleErrorModal = () => {
    if (success === 0) {
      if (statusCode === 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message="Session Expired. Please Login Again!"
            buttonText="Logout"
            onPress={() => dispatchResetSession()}
            statusCode={statusCode}
          />
        );
      } else if (!!error && statusCode !== 401) {
        return (
          <ErrorSuccessModal
            type="error"
            isOpen={!!error}
            title="Error"
            message={error}
            buttonText="OK"
            onPress={() => {
              dispatchResetTimeSheetReportError();
            }}
          />
        );
      }
    }

    return false;
  };
  return (
    <div>
      <Modal
        centered
        isOpen={isOpen}
        toggle={toggle}
        size="sg"
        backdrop="static"
      >
        <ModalHeader
          className="pt-3 pl-4"
          id="cross-cut"
          toggle={toggle}
          style={{ paddingBottom: "13px" }}
        >
          Missing Timesheet Report
        </ModalHeader>
        <ModalBody
          className="pl-4 pr-4"
          style={{ paddingLeft: "40px", minHeight: "70vh" }}
        >
          <>
            {fetching ? (
              <TableLoader Rows={10} ColumnPerRow={7} />
            ) : unfilledTimesheetReportList?.length > 0 ? (
              <div className="jobsType pl-0 pr-0">
                <table className="table thead-light table-bordered">
                  <thead className="text-start sticky-table-header">
                    <tr className="new-table-head">
                      <td>
                        <strong>Total Days</strong>
                      </td>
                      <td>
                        <strong>
                          {typeof unfilledTimesheetCount === "number" &&
                          unfilledTimesheetCount
                            ? unfilledTimesheetCount
                            : 0}
                        </strong>
                      </td>
                    </tr>
                    <TableHeader
                      tableHeader={TIMESHEET_UNFILLED_REPORT_HEADERS}
                    />
                  </thead>
                  <tbody>
                    <TimeSheetUnfilledDatesReportTable
                      data={unfilledTimesheetReportList}
                      tableHeaders={TIMESHEET_UNFILLED_REPORT_HEADERS}
                    />
                  </tbody>
                </table>
              </div>
            ) : (
              <div className="mt-5">
                {!fetching && data?.length === 0 && (
                  <EmptyListPage title="No List Found!" imageWidth="30%" />
                )}
              </div>
            )}
          </>
        </ModalBody>
      </Modal>
      {/* <Toaster /> */}
      {handleErrorModal()}
    </div>
  );
};

const mapStateToProps = (state: RootState) => ({
  token: state.auth.token,
  error: state.timeSheet.error,
  statusCode: state.timeSheet.statusCode,
  success: state.timeSheet.success,
  message: state.timeSheet.message,
  fetching: state.timeSheet.fetching,
  unfilledTimesheetReportList: state.timeSheet.unfilledTimesheetReportList,
  unfilledTimesheetCount: state.timeSheet.unfilledTimesheetCount,
});
const mapDispatchToProps = (dispatch: any) => ({
  dispatchResetSession: () => dispatch(resetSession()),
  dispatchResetTimeSheetReportSuccess: () => dispatch(resetTimeSheetSuccess()),
  dispatchResetTimeSheetReportError: () => dispatch(resetTimeSheetError()),
  dispatchResetTimeSheetReportMessage: () => dispatch(resetTimeSheetMessage()),
  dispatchResetTimeSheetReportStatusCode: () =>
    dispatch(resetTimeSheetStatusCode()),
  dispatchResetUnfilledTimeSheetReportTotalCount: () =>
    dispatch(resetUnfilledTimesheetCount()),
  dispatchResetUnfilledTimeSheetReportListing: () =>
    dispatch(resetUnfilledTimesheetReportList()),
  dispatchGetTimeSheetUnfilledDatesReportAction: (
    data: GetMissingTimesheetSummaryReport
  ) => dispatch(getTimeSheetUnfilledReportAction(data)),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(OpenTimeSheetUnfilledDateModal);
